/** @jsx jsx */
import { Button } from "@cd2/components"
import { jsx } from "@emotion/core"
import { Link } from "react-router-dom"
import { IComponentProps } from "../types/utils"

type Props = IComponentProps<typeof Button> & { to: string; external?: boolean }

export function LinkButton({ to, children, external, ...props }: Props) {
  if (external) {
    return (
      <a href={props.disabled ? "#" : to} target="_blank" rel="noreferrer">
        <Button {...props}>{children}</Button>
      </a>
    )
  }
  return (
    <Link to={props.disabled ? "#" : to}>
      <Button {...props}>{children}</Button>
    </Link>
  )
}
